// extracted by mini-css-extract-plugin
export default {"header":"Header_header__eXUV4","logo":"Header_logo__v-tql","for":"Header_for__YVLxI"};